import React from "react";
import CustomerSleeveHeader from "./CustomerSleeveHeader";
import CustomerSleeveFooter from "./CustomerSleeveFooter";
import './ClientSleeve.css';

export default function CustomerSleeveLayout({ envelopeData, children }) {
  return (
    <div className="customer-sleeve-layout d-flex flex-column" style={{ minHeight: 'calc(100vh - 140.5px)' }}>
      <CustomerSleeveHeader
        recipientName={envelopeData?.recipient_name}
        dueDate={envelopeData?.due_date}
      />
      <main className="flex-grow-1 d-flex flex-column" style={{ minHeight: 0 }}>
        {children}
      </main>
      <CustomerSleeveFooter />
    </div>
  );
} 